import api from '../../../api/axios';

export const communityHttpClient = api;

export default communityHttpClient;
